// src/utils/stripe.js
import { loadStripe } from '@stripe/stripe-js'

// Determine which Stripe public key to use based on environment
// In production (digipalz.io), use live Stripe key if available
const isProduction =
  import.meta.env.PROD || import.meta.env.MODE === 'production'
const isProductionDomain =
  typeof window !== 'undefined' &&
  (window.location.hostname === 'digipalz.io' ||
    window.location.hostname === 'www.digipalz.io' ||
    window.location.hostname === 'digipalz.ca' ||
    window.location.hostname === 'www.digipalz.ca')

const stripePublicKey =
  isProductionDomain && import.meta.env.VITE_STRIPE_LIVE_PUBLIC_KEY
    ? import.meta.env.VITE_STRIPE_LIVE_PUBLIC_KEY
    : import.meta.env.VITE_STRIPE_PUBLIC_KEY

let stripePromiseInstance = null

export const getStripePromise = () => {
  if (!stripePublicKey) {
    throw new Error(
      'VITE_STRIPE_PUBLIC_KEY or VITE_STRIPE_LIVE_PUBLIC_KEY environment variable is not set. Please configure it in your .env file or environment variables.'
    )
  }

  if (!stripePromiseInstance) {
    stripePromiseInstance = loadStripe(stripePublicKey)
  }

  return stripePromiseInstance
}
